import React, { useState, useEffect } from 'react'
import Icono_cata from '../../assets/img/Iconoexport.svg'
import { config } from '../../config'
import { Loader } from '../Loader'
import { set } from 'date-fns'
// import { getListPromotionById } from '../services/listPromotionById.service'
// import { updateStateMoves } from '../services/updateStateMoves.service'

// /offer/possible_moves/<offer_id>

function getPosiblesMoves(id_oferta) {
	const session_token = localStorage.getItem('session')
	//console.log(session_token);
	//if there is a session token stored
	if (session_token) {
		return fetch(config.apiUrlOferta + `/offer/possible_moves/`+id_oferta, {
			//mode: 'no-cors',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + session_token,
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Credentials': true,
			},
		})
			.then((response) => {
				//console.log(response.ok)
				return response.json()
			})
			.then((response) => {
				//console.log(response)
				return response
			})
	}

	//there are no session token stored
	return {}
}

export const MoveOffer = ({ setActive, idOffer, setMover, promotion }) => {

    console.log("INfo de la promocion:::")
    console.log(promotion)

	const [states, setStates] = useState(null)
	const [state_select, setState_select] = useState('')
	const [promotion_select, setPromotion_select] = useState(null)
    const [loading, setLoading] = useState(true)

    const handleSelectChange = (event) => {
		const selectedValue = event.target.value
		setState_select(selectedValue)
		// Aquí puedes realizar las acciones adicionales según la opción seleccionada
		// ...
	}

    useEffect(() => {
        getPosiblesMoves(idOffer).then((response) => {
            console.log("POSIBLES MOVIMIENTOS::: ")
            console.log(response)
            setStates(response)
            setLoading(false)
        })
    }, [])

    const movePromotionOffer = async (promotion_id, promotionalstate_id) => {
		setLoading(true)
		const session_token = localStorage.getItem('session');
		if (session_token){
		  
			const response = await fetch(config.apiUrlOferta + `/offer/update_phase`, {
			//mode: 'no-cors',
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json',
			  'Authorization': 'Bearer ' + session_token,
			  "Access-Control-Allow-Origin" : "*", 
			  "Access-Control-Allow-Credentials" : true
			},
			body: JSON.stringify({
				promotionalstate_id: parseInt(promotionalstate_id),
				promotion_id: parseInt(promotion_id),
				comment_text: document.getElementById("comentario").value
			}),
		  })
		  const responseJSON = await response.json();
		  console.log("Cambio de estado o fase desde oferta");
		  console.log(responseJSON);
		  setLoading(false)
          // alert("Se ha movido la promoción de estado")
          setActive(false)
		  // window.location.reload();
	
		}
	  
	  }

	return (
        <>
        {loading && <Loader message={"Cargando..."}/>}
		{!loading && (<div
			className='popupWrapper OfertaWrapper'
			id='popupCatalog'
			onClick={(e) => {
				if (e.target.id == 'popupCatalog') {
					setActive(false)
				}
			}}
		>
			<div className='popup SaveCatalog ExportPop' style={{ height: 480 }}>
				<div className='topexport'>
					<img src={Icono_cata} alt='' />
					<h1>Mover Catálogo</h1>
				</div>
				<ul className='list_diff'>
					<li>
						<h1>Fase</h1>
						<span>{promotion.offer_data.phase}</span>
					</li>
					<li>
						<h1>Estado</h1>
						<span>{promotion.offer_data.state}</span>
					</li>
				</ul>
				<p className='special_p'>Elige el destino de la Promoción</p>

				<a href='#' className='special_a'>
                {promotion.offer_data.promotion_name}
				</a>
				{/* value={selectedOption} onChange={handleSelectChange} */}
				<div className='select_area'>
					<label htmlFor=''>Estado</label>
					<select
						id='state_select_move'
						value={state_select}
						onChange={handleSelectChange}
					>
						<option>Selecciona un Estado</option>
						{!states
							? 'Cargando Fases...'
							: states.map((EachRow) => {
									return (
										<option value={EachRow.id}>
											{EachRow.state_phase_str}
										</option>
									)
							  })}
					</select>
				</div>
				<textarea id='comentario'
					name=''
					cols='30'
					rows='5'
					placeholder='Deja un comentario.. (opcional)'
				></textarea>
				<p>*El catálogo avanzará a la etapa indicada</p>

				<div className='banner_warn' style={{ width: '100%' }}>
					<svg
						width='23'
						height='24'
						viewBox='0 0 23 24'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<mask
							id='mask0_2319_430587'
							maskUnits='userSpaceOnUse'
							x='0'
							y='0'
							width='23'
							height='24'
						>
							<rect y='0.5' width='23' height='23' fill='#D9D9D9' />
						</mask>
						<g mask='url(#mask0_2319_430587)'>
							<path
								d='M11.4998 17.3428C11.8991 17.3428 12.2145 17.235 12.4461 17.0193C12.6777 16.8037 12.7935 16.4883 12.7935 16.073C12.7935 15.6737 12.6817 15.3542 12.4581 15.1146C12.2345 14.8751 11.9151 14.7553 11.4998 14.7553C11.1005 14.7553 10.785 14.8751 10.5534 15.1146C10.3218 15.3542 10.206 15.6737 10.206 16.073C10.206 16.4723 10.3178 16.7837 10.5415 17.0074C10.7651 17.231 11.0845 17.3428 11.4998 17.3428ZM11.5717 13.1501C11.8911 13.1501 12.1507 13.0502 12.3503 12.8506C12.55 12.6509 12.6498 12.3834 12.6498 12.048V7.7834C12.6498 7.46395 12.55 7.20441 12.3503 7.00475C12.1507 6.8051 11.8911 6.70527 11.5717 6.70527C11.2522 6.70527 10.9887 6.8051 10.781 7.00475C10.5734 7.20441 10.4696 7.46395 10.4696 7.7834V12.048C10.4696 12.3834 10.5774 12.6509 10.793 12.8506C11.0086 13.0502 11.2682 13.1501 11.5717 13.1501ZM11.4998 22.0865C10.1102 22.0865 8.80048 21.827 7.57062 21.3079C6.34076 20.7888 5.26663 20.07 4.34823 19.1516C3.42982 18.2332 2.71107 17.1591 2.19198 15.9292C1.67288 14.6994 1.41333 13.3896 1.41333 12.0001C1.41333 10.5945 1.67288 9.28079 2.19198 8.05892C2.71107 6.83704 3.42982 5.76691 4.34823 4.8485C5.26663 3.9301 6.34076 3.20736 7.57062 2.68027C8.80048 2.15319 10.1102 1.88965 11.4998 1.88965C12.8894 1.88965 14.2031 2.15319 15.4409 2.68027C16.6788 3.20736 17.7529 3.9301 18.6633 4.8485C19.5737 5.76691 20.2925 6.84104 20.8196 8.0709C21.3467 9.30076 21.6102 10.6105 21.6102 12.0001C21.6102 13.4056 21.3467 14.7193 20.8196 15.9412C20.2925 17.1631 19.5698 18.2292 18.6514 19.1396C17.7329 20.0501 16.6588 20.7688 15.429 21.2959C14.1991 21.823 12.8894 22.0865 11.4998 22.0865ZM11.4998 19.9063C13.688 19.9063 15.5527 19.1357 17.0941 17.5943C18.6354 16.053 19.406 14.1883 19.406 12.0001C19.406 9.81187 18.6354 7.94711 17.0941 6.40579C15.5527 4.86447 13.688 4.09382 11.4998 4.09382C9.31159 4.09382 7.44684 4.86447 5.90552 6.40579C4.3642 7.94711 3.59354 9.81187 3.59354 12.0001C3.59354 14.1883 4.3642 16.053 5.90552 17.5943C7.44684 19.1357 9.31159 19.9063 11.4998 19.9063Z'
								fill='#FFAC23'
							/>
						</g>
					</svg>

					<p>
						<span>
                            
							Siempre recuerde guardar avances. Una vez que el catálogo avance de fase, no podrá retroceder. Si
							está seguro, presione Mover.
						</span>
					</p>
				</div>

				<div className='buttons_wrapper'>
					<button
						onClick={(e) => {
							setActive(false)
						}}
					>
						Cancelar
					</button>
					<button
						onClick={(e) => {
							// if (
							// 	document.getElementById('state_select_move').value === '' ||
							// 	!document.getElementById('state_select_move').value
							// ) {
							// 	alert('Seleccione un estado.')
							// 	return false
							// }
							// handleMoveState(promotion_select, state_select)
							console.log('clie')
                            if(state_select !== '' && state_select !== 'Selecciona un Estado' && state_select !== null && state_select !== undefined){
                                movePromotionOffer(idOffer, state_select)
                            }else{
                                alert("Debe seleccionar un estado");
                            }
						}}
					
					>
						Mover
					</button>
				</div>
			</div>
		</div>
        )}
        </>
	)
}
